/**
 * Finds the difference from both sets.
 */
export function difference<T>(a: Set<T>, b: Set<T>) {
  const result = new Set<T>();
  for (const item of a) {
    if (!b.has(item)) {
      result.add(item);
    }
  }

  for (const item of b) {
    if (!a.has(item)) {
      result.add(item);
    }
  }

  return result;
}

/**
 * Finds the differences in the "left" set
 */
export function leftDifference<T>(left: Set<T>, right: Set<T>) {
  const result = new Set<T>();
  for (const item of left) {
    if (!right.has(item)) {
      result.add(item);
    }
  }
  return result;
}

/**
 * Finds the intersection between the two sets
 */
export function intersection<T>(a: Set<T>, b: Set<T>) {
  const result = new Set<T>();

  for (const item of a) {
    if (b.has(item)) {
      result.add(item);
    }
  }

  for (const item of b) {
    if (a.has(item)) {
      result.add(item);
    }
  }

  return result;
}
